import { type TBreakpointsState, type TBreakpointState, useBreakpointsContext } from "context/breakpointsContext";
import { useMemo } from "react";
import { requirePropertyOf } from "utils/security";
import { Breakpoint, type TBreakpointOption } from "utils/ui/breakpoints";

const getEnumKeyByValue = (value: number) =>
  Object.keys(Breakpoint)[Object.values(Breakpoint).indexOf(value)] as keyof typeof Breakpoint;

export function useBreakpoints(option: TBreakpointOption): TBreakpointState;
export function useBreakpoints(): TBreakpointsState["state"];
export function useBreakpoints(option?: TBreakpointOption) {
  const { state } = useBreakpointsContext();
  const breakpoint = useMemo(() => {
    if (!option) return state;
    const breakpointAsName = typeof option === "number" ? getEnumKeyByValue(option) : option;
    return requirePropertyOf(state, breakpointAsName);
  }, [option, state]);

  return breakpoint;
}
